import { ArrowRight } from "zudoku/icons";
import { products } from "./products.js";
import "./portal.css";

export const SiteFooter = () => (
  <footer className="ax-site-footer">
    <section className="ax-service-banner">
      <div className="ax-container ax-service-inner">
        <div>
          <h2>专业技术服务团队</h2>
          <p>从产品咨询到部署交付，全程为您服务</p>
          <a href="/support">
            联系产品顾问 <ArrowRight size={16} />
          </a>
        </div>
        <div className="ax-service-points">
          <span>产品方案咨询</span>
          <span>专属技术服务</span>
          <span>系统部署支持</span>
          <span>使用指导与支持</span>
        </div>
      </div>
    </section>
    <div className="ax-footer-dark">
      <div className="ax-container">
        <div className="ax-footer-columns">
          <div className="ax-footer-column">
            <h3>产品与服务</h3>
            {products.map((product) => (
              <a key={product.id} href={`/${product.id}/features`}>
                {product.name}
              </a>
            ))}
          </div>
          <div className="ax-footer-column">
            <h3>文档中心</h3>
            <a href="/overview">产品总览</a>
            <a href="/live/demo">系统演示</a>
            <a href="/live/features">功能介绍</a>
            <a href="/live/architecture">技术框架</a>
          </div>
          <div className="ax-footer-column">
            <h3>服务支持</h3>
            <a href="/support">产品咨询</a>
            <a
              href="http://192.168.112.171:9224/"
              target="_blank"
              rel="noreferrer"
            >
              安象官网
            </a>
            <a href="tel:13277158907">13277158907</a>
            <span>QQ：186571635</span>
          </div>
          <div className="ax-footer-contact">
            <h3>武汉安象信息科技有限公司</h3>
            <p>
              电话：<a href="tel:13277158907">13277158907</a>
            </p>
            <p>地址：湖北省武汉市洪山区高新大道</p>
            <div className="ax-footer-qr">
              <figure>
                <img
                  src="/brand/official-account.jpg"
                  alt="安象公众号二维码"
                  width="80"
                  height="80"
                />
                <figcaption>公众号</figcaption>
              </figure>
              <figure>
                <img
                  src="/brand/wechat.jpg"
                  alt="安象微信联系二维码"
                  width="80"
                  height="80"
                />
                <figcaption>微信咨询</figcaption>
              </figure>
            </div>
          </div>
        </div>
        <div className="ax-footer-legal">
          <img
            src="/brand/footer-logo.png"
            alt="安象科技"
            width="99"
            height="30"
          />
          <p>
            © 武汉安象信息科技有限公司 版权所有{" "}
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noreferrer"
            >
              鄂ICP备18029487号-1
            </a>
          </p>
        </div>
      </div>
    </div>
  </footer>
);
